import { withLocale, USER_INFO_PATH, COUPON_INDEX_PATH } from '@/util/categoryRoute'

// 用户中心相关
const userInfoRoutes = [
  {
    path: USER_INFO_PATH,
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: '',
        name: 'USERINFO',
        component: () => import('@/views/userinfo/index.vue'),
        meta: {
          cnName: '用户信息',
          enName: 'User Info'
        }
      },
      {
        path: withLocale('/userInformation'),
        name: 'userInformation',
        component: () => import('@/views/userinfo/compontent/userInformation.vue'),
        meta: {
          cnName: '用户信息',
          enName: 'User Info'
        }
      },
      {
        path: COUPON_INDEX_PATH,
        name: 'COUPONINDEX',
        component: () => import('@/views/userinfo/coupon/CouponIndex.vue'),
        meta: {
          cnName: '优惠券',
          enName: 'Coupon'
        }
      },
      {
        path: withLocale('/userwallet'),
        name: 'Wallet',
        component: () => import('@/views/userinfo/userwallet/Index.vue'),
        meta: {
          cnName: '用户钱包',
          enName: 'User Wallet'
        }
      },
      {
        path: withLocale('/withdraw'),
        name: 'WithDraw',
        component: () => import('@/views/userinfo/userwallet/withdraw.vue'),
        meta: {
          cnName: '提现',
          enName: 'Withdraw'
        }
      },
      {
        path: withLocale('/contactUs'),
        name: 'contactUs',
        component: () => import('@/views/customerService/contactUs/index.vue'),
        meta: {
          cnName: '联系我们',
          enName: 'contactUs'
        }
      },
      {
        path: withLocale('/coin-list'),
        name: 'coinList',
        component: () => import('@/views/userinfo/coinbase/index.vue'),
        meta: {
          cnName: '币种列表',
          enName: 'Coin list'
        }
      }
    ]
  }
]

export default userInfoRoutes
